import { ShieldCheck, Activity, Wand2 } from "lucide-react";
import ProductPage from "@/components/ProductPage";
import {
  useDocumentTitle,
  DEFAULT_STEPS,
  DEFAULT_INTEGRATIONS,
} from "@/lib/shared";

const FEATURES = [
  {
    Icon: ShieldCheck,
    title: "Control Total",
    desc: "Panel centralizado para gestionar usuarios y licencias.",
  },
  {
    Icon: Activity,
    title: "Calidad Garantizada",
    desc: "Herramientas de monitoreo en tiempo real (tecnología AudioCodes Live).",
  },
  {
    Icon: Wand2,
    title: "Simplicidad",
    desc: "Wizards de configuración que eliminan la complejidad técnica.",
  },
];

const ConnectPage = () => {
  useDocumentTitle("Caruna Connect — Gestión y Control de Voz");
  return (
    <ProductPage
      category="connect"
      eyebrow="GESTIÓN Y CONTROL"
      headline="Caruna Connect"
      subhead="Administra, Monitorea y Asegura tu voz desde un solo lugar."
      features={FEATURES}
      steps={DEFAULT_STEPS}
      integrations={DEFAULT_INTEGRATIONS}
      ctaHeadline="Solicita una evaluación técnica de Caruna Connect"
      baseTech="AudioCodes Live Multi-tenant"
      heroBody="Caruna Connect es la capa de gestión y control que se instala sobre tu plataforma UCaaS: consola centralizada para administrar usuarios y licencias, monitoreo en tiempo real de la calidad de voz con tecnología AudioCodes Live y wizards de configuración que eliminan la complejidad técnica del despliegue."
    />
  );
};

export default ConnectPage;
